import { render, staticRenderFns } from "./DoubleSection.vue?vue&type=template&id=5a86c134&scoped=true&"
import script from "./DoubleSection.vue?vue&type=script&lang=js&"
export * from "./DoubleSection.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSection.vue?vue&type=style&index=0&id=5a86c134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86c134",
  null
  
)

export default component.exports